module.exports = __webpack_public_path__ + "static/media/iconDelete2.6835fdbd.svg";